import { CodeEditor } from "../components";
const Home = () => {
  return (
    <>
      <CodeEditor />
    </>
  );
};

export default Home;
